import { render, staticRenderFns } from "./studentInfo-switch-class.vue?vue&type=template&id=65091bc8&scoped=true"
import script from "./studentInfo-switch-class.vue?vue&type=script&lang=js"
export * from "./studentInfo-switch-class.vue?vue&type=script&lang=js"
import style0 from "./studentInfo-switch-class.vue?vue&type=style&index=0&id=65091bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65091bc8",
  null
  
)

export default component.exports